import { ClientInfoDisplay } from '@/features/client/components/client-info-display'
import { ClientRegistrationFlow } from '@/features/client/components/client-registration-flow'
import { CnpjSearchForm } from '@/features/client/components/cnpj-search-form'

import { FeedbackDialogWrapper } from '@/features/client/components/feedback-dialog-wrapper'
import { SignContractPopup } from '@/features/client/components/sign-contract-popup'
import { ClientProvider } from '@/context/client'
import { PageLayout } from '@/layouts'

export default function ClienteConsultForm() {
  return (
    <ClientProvider>
      <ClientConsultFormContent />
    </ClientProvider>
  )
}

function ClientConsultFormContent() {
  return (
    <PageLayout title="Cadastrar Cliente">
      <CnpjSearchForm />
      <ClientInfoDisplay />
      <ClientRegistrationFlow />
      <SignContractPopup />

      <FeedbackDialogWrapper />
    </PageLayout>
  )
}
